import { render, staticRenderFns } from "./DealsClosing.vue?vue&type=template&id=2389c9cb&"
import script from "./DealsClosing.vue?vue&type=script&lang=js&"
export * from "./DealsClosing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports